export default __webpack_public_path__ + "static/media/kitchen3-afterJ-480w.f353d435.png";